// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"195":"67e104bc8fd1f1995773","253":"72b32bcb82c3c03b97a4","529":"622ab47d4b8dcbf000e2","592":"39997b1d820a4b8ad322"}[chunkId] + ".js";
};